<template>
    <b-modal id="facility_staff" ref="facility_staff" @hidden="resetModal"
             no-close-on-backdrop
             :header-class="{'no-border': mode === 'unassign'}" :footer-class="{'no-border' : mode === 'unassign'}">

        <template v-slot:modal-title>
            <div v-if="mode === 'assign'">
                Assign Staff
            </div>

            <div v-if="mode === 'unassign'">
                Unassign {{staffData ? staffData.data.attributes.name : ''}}
            </div>
        </template>

        <div v-if="mode === 'assign'" class="mb-4">
            Assigning a staff does not mean they will administer the facility! The staff will be responsible for data
            entry specified as their job role/responsibilities.
        </div>

        <div v-if="mode === 'unassign'">
            You can't revert back your action if you unassign this user. For further query, contact Database Manager!
        </div>

        <b-form v-if="mode === 'assign'">
            <b-row v-if="validationError">
                <b-colxx md="12">
                    <b-alert class="text-center" show variant="danger"
                             v-text="validationError"/>
                </b-colxx>
            </b-row>

            <b-row class="">
                <b-colxx md="6">
                    <b-form-group label="Date" class="has-float-label">
                        <template v-slot:label>
                            <span>Date <sup><code>*</code></sup></span>
                        </template>

                        <v-date-picker
                            popover-visibility="focus" mode="single"
                            v-model="datepicker.date"
                            @input="'date' in errors ? delete errors.date : ''"
                            :input-props="{ class:'form-control' + ('date' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>

                        <b-form-invalid-feedback :state="!'date' in errors"
                                                 v-text="'date' in errors ? errors.date[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="6">
                    <b-form-group label="Assigned As" class="has-float-label">
                        <template v-slot:label>
                            <span>Assigned As <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateAssigned" v-model="selected.assignment" :options="assignments"
                                  :border-danger="'assigned_as' in errors"/>

                        <b-form-invalid-feedback :state="!'assigned_as' in errors"
                                                 v-text="'assigned_as' in errors ? errors.assigned_as[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row class="mb-n4">
                <b-colxx md="12">
                    <b-form-group label="Staff" class="has-float-label">
                        <template v-slot:label>
                            <span>Staff <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateStaff" v-model="selected.staff" :options="staff"
                                  :border-danger="'user_id' in errors"/>

                        <b-form-invalid-feedback :state="!'user_id' in errors"
                                                 v-text="'user_id' in errors ? errors.user_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
        </b-form>

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('facility_staff')" v-text="'Cancel'"/>

            <state-button v-if="mode === 'assign'" size="sm" variant="primary" :click="submitStaff">Submit</state-button>
            <state-button v-if="mode === 'unassign'" size="sm" variant="danger" :click="unassignStaff">Unassign</state-button>
        </template>
    </b-modal>
</template>

<script>
    import {mapGetters} from 'vuex';
    import StateButton from "../../../../../components/Common/StateButton";
    import moment from "moment";

    export default {
        name: "FacilityStaffModal",

        components: {
            StateButton,
        },

        props: [
            'facility', 'staffData', 'mode'
        ],

        data() {
            return {
                datepicker: {
                    date: null,
                },
                assignments: [
                    {label: 'Vendor Manager', value: 'Vendor Manager'},
                    {label: 'Inspector', value: 'Inspector'},
                ],
                validationError: null,
                selected: {
                    staff: [],
                    assignment: [],
                },
            }
        },

        computed: {
            ...mapGetters({
                form: 'getFacilityStaffForm',
                staff: 'getSelectUsers',
                errors: 'getFacilityErrors',
            }),
        },

        watch: {
            'datepicker.date'(date) {
                if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.date = null;
                this.form.date = moment(date).format('YYYY-MM-DD');
            },
        },

        mounted() {
            this.getStaff();
        },

        methods: {
            async getStaff() {
                await this.$store.dispatch('fetchSelectUsers');
            },

            updateStaff(field) {
                if (field) {
                    this.form.user_id = field.user_id;
                } else {
                    this.form.user_id = '';
                }
                'user_id' in this.errors ? delete this.errors.user_id : '';
            },

            updateAssigned(field) {
                if (field) {
                    this.form.assigned_as = field.value;
                } else {
                    this.form.assigned_as = '';
                }
                'assigned_as' in this.errors ? delete this.errors.assigned_as : '';
            },

            submitStaff() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('submitFacilityStaff', this.form)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('updated');

                                this.$notify('success filled', 'Success!', 'Assigned new staff!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('facility_staff');
                            }, 2000);
                        })
                        .catch(error => {
                            if (error.response.data.error) {
                                this.validationError = error.response.data.error;
                            }

                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },

            unassignStaff() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('unassignFacilityStaff', this.staffData)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('updated');

                                this.$notify('warning filled', 'Success!', 'Unassigned ' + this.staffData.data.attributes.name + '!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('facility_staff');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },

            resetModal() {
                this.$store.commit('setFacilityStaffForm');

                this.datepicker =  {
                    date: null,
                };

                this.selected = {
                    staff: [],
                };

                this.validationError = null;
            },

            hideModal(refname) {
                this.$refs[refname].hide();
            },
        },
    }
</script>

<style scoped>

</style>
